import React, { FC } from "react";
import { Button, Typography } from "@mui/material";

interface DelendButtonProps {
  onClick?: () => void;
  text: string;
  fullWidth?: boolean;
  startIcon?: React.ReactNode;
  padding?: number | string;
  disabled?: boolean;
}

const DelendButton: FC<DelendButtonProps> = ({
  onClick,
  text,
  fullWidth,
  startIcon,
  padding,
  disabled,
}) => {
  return (
    <Button
      sx={{ textTransform: "none", borderRadius: 50, padding: padding }}
      onClick={onClick}
      type="submit"
      variant="contained"
      fullWidth={fullWidth}
      startIcon={startIcon}
      disabled={disabled ?? false}
    >
      <Typography sx={{ fontWeight: 600, fontSize: 14 }} color="inherit" noWrap>
        {text}
      </Typography>
    </Button>
  );
};

export default DelendButton;
